// Escenarios (dioramas) que se pueden añadir a la figura desde el
// configurador. Se cobran una vez por pedido (no por unidad) y se guardan en
// figuraConfig.escenarioPack — ojo: "escenarios" (colección) es la
// herramienta interna de presupuestos a medida del admin, no esto.
//
// Precio por valor, no por piezas: los genéricos son la gama de entrada
// (nunca por debajo de 24,90 €) y la réplica de una iglesia real es una pieza
// única. La réplica se cobra "desde" y el precio final se confirma al
// cliente tras ver las fotos, antes de producir.
export type EscenarioPackId = 'basico' | 'altar' | 'capilla' | 'replica';

export interface EscenarioPack {
  id: EscenarioPackId;
  price: number;
  image: string;
  /** Precio orientativo: el final se confirma tras ver las fotos. */
  desde?: boolean;
}

export const ESCENARIO_PACKS: EscenarioPack[] = [
  { id: 'basico', price: 24.9, image: '/seo/escenario-pack-basico.jpg' },
  { id: 'altar', price: 39.9, image: '/seo/escenario-pack-altar.jpg' },
  { id: 'capilla', price: 39.9, image: '/seo/escenario-pack-capilla.jpg' },
  { id: 'replica', price: 149, image: '/seo/escenario-replica-parroquia.jpg', desde: true },
];

// Nombre en castellano para el admin, facturas y emails internos.
export const ESCENARIO_NOMBRE: Record<EscenarioPackId, string> = {
  basico: 'Escenario Esencial',
  altar: 'Escenario Altar',
  capilla: 'Escenario Capilla',
  replica: 'Réplica de iglesia',
};

export const MAX_FOTOS_REPLICA = 4;

export function escenarioPrice(id: string | null | undefined): number {
  return ESCENARIO_PACKS.find(p => p.id === id)?.price ?? 0;
}
